import React from "react";

const Payment = () => {
  return (
    <div>
      <h3>this is payment pagee</h3>
    </div>
  );
};

export default Payment;
